import React from "react";
import styled from "styled-components";
import { Button } from "@mui/material";

const CourseDescriptionModalContent = ({
  title,
  description,
  onClose,
}) => {
  return (
    <Wrapper>
      <HeaderText>INFORMACIÓN SOBRE EL CURSO</HeaderText>

      <CourseTitle>{title}</CourseTitle>

      <Description>{description}</Description>
    </Wrapper>
  );
};

export default CourseDescriptionModalContent;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  overflow: hidden;
`;

const HeaderText = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #8a8a8a;
  margin-bottom: 8px;
`;

const CourseTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: rgb(80, 124, 19);
  margin-bottom: 12px;
`;

const Description = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: #444;

  flex: 1;
  overflow-y: auto;
  margin-bottom: 16px;
`;